import React from 'react'

import { NavList } from './components/NavList/NavList'
import { useDrawer, useDrawerControls } from './Drawer.hook'
import { StyledDrawer } from './Drawer.styled'

const Drawer = ({companyNavigation, profilNavigation}) => {

  const { items, layoutState, slideRef } = useDrawer(companyNavigation, profilNavigation)
  const { onClickNext } = useDrawerControls()

  return (
     <StyledDrawer $isOpen={layoutState.menuIsOpen} >
      <NavList
        key={'MainNav'}
        items={items}
        onClickNext={onClickNext}
        ref={slideRef}
        companyNavigation={companyNavigation}
        isOpen
      />
     </StyledDrawer>
  )
}

export default Drawer